export default {
    props: {
        values: {
            type: Object
        }
    },
    computed: {
        isVisible() {
            const logic = this.item.type === 'formsection' ? this.item.data.logic : this.item.logic;

            if(Array.isArray(logic) && logic.length === 0) {
                return true;
            }

            let finalResult = logic['and_or'] === 'all';

            for (let i = 0; i < logic.rules.length; i++) {
                let conditionsMet = false;
                let source = logic.rules[i].source;
                let value = logic.rules[i].value;

                if (Array.isArray(this.values[source])) { // checkbox
                    conditionsMet = this.values[source].includes(value);
                }
                else { // radio or select
                    conditionsMet = this.values[source] === value;
                }

                if(logic.rules[i].compare !== "is") {
                    conditionsMet = !conditionsMet;
                }

                if(logic["and_or"] === "any" && conditionsMet){   // any of the conditions have to be met
                    finalResult = true;
                    break;  // exit loop, condition has been met
                }
                if(logic["and_or"] === "all" && !conditionsMet){  // all of the conditions have to be met
                    finalResult = false;
                    break;  // exit loop, condition cant be met anymore
                }
            }

            if(logic.hide_show === 'show' && finalResult) {
                return true;
            } else if (logic.hide_show === 'show') {
                return false;
            }
            else if(logic.hide_show === 'hide' && finalResult) {
                return false;
            } else if (logic.hide_show === 'hide') {
                return true;
            }

            // let finalResult = this.item.logic['and_or'] === 'all';
            //
            // for (let i = 0; i < this.item.logic.rules.length; i++) {
            //     let conditionsMet = false;
            //     let source = this.item.logic.rules[i].source;
            //     let value = this.item.logic.rules[i].value;
            //
            //     if (Array.isArray(this.values[source])) { // checkbox
            //         conditionsMet = this.values[source].includes(value);
            //     }
            //     else { // radio or select
            //         conditionsMet = this.values[source] === value;
            //     }
            //
            //     if(this.item.logic.rules[i].compare !== "is") {
            //         conditionsMet = !conditionsMet;
            //     }
            //
            //     if(this.item.logic["and_or"] === "any" && conditionsMet){   // any of the conditions have to be met
            //         finalResult = true;
            //         break;  // exit loop, condition has been met
            //     }
            //     if(this.item.logic["and_or"] === "all" && !conditionsMet){  // all of the conditions have to be met
            //         finalResult = false;
            //         break;  // exit loop, condition cant be met anymore
            //     }
            // }
            //
            // if(this.item.logic.hide_show === 'show' && finalResult) {
            //     return true;
            // } else if (this.item.logic.hide_show === 'show') {
            //     return false;
            // }
            // else if(this.item.logic.hide_show === 'hide' && finalResult) {
            //     return false;
            // } else if (this.item.logic.hide_show === 'hide') {
            //     return true;
            // }
        }
    }
};